module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "hero"
  }, [_vm._t("hero")], 2), _vm._v(" "), _c('div', {
    staticClass: "form-section"
  }, [_vm._t("form-section")], 2), _vm._v(" "), _c('div', [_vm._t("first-row")], 2), _vm._v(" "), _c('div', [_vm._t("second-row")], 2), _vm._v(" "), _c('div', [_vm._t("third-row")], 2), _vm._v(" "), _c('div', [_vm._t("fourth-row")], 2), _vm._v(" "), _c('div', [_vm._t("fifth-row")], 2), _vm._v(" "), _c('div', {
    staticClass: "google-reviews"
  }, [_vm._t("google-reviews")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55586134"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/IndustrySingle.vue
// module id = 1967
// module chunks = 5